export default __webpack_public_path__ + "bfx/static/media/icon-EVENTS.e0d3c861.svg";